import { render, staticRenderFns } from "./forkliftDetail.vue?vue&type=template&id=34f0c93a&scoped=true"
import script from "./forkliftDetail.vue?vue&type=script&lang=js"
export * from "./forkliftDetail.vue?vue&type=script&lang=js"
import style0 from "./forkliftDetail.vue?vue&type=style&index=0&id=34f0c93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f0c93a",
  null
  
)

export default component.exports